import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { DadosUsuarioInput, MensagemErro, UsuarioModel } from 'src/app/models/usuario';
import { Retorno } from 'src/app/models/comboModel';

/** Filtros por coluna e ordenação da Relação de Usuários (espelha SegUsuarioListaFiltro no backend). */
export interface UsuarioListaFiltro {
  login?: string;
  nome?: string;
  nomeEmpresa?: string;
  email?: string;
  nomeHierarquia?: string;
  perfil?: string;
  ultimoAcesso?: string;
  sortField?: string;
  sortOrder?: number;
}

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  private environmentUrl: string = '';

  dialogUsuario = new EventEmitter();
  dialogUsuarioMotivoAusencia = new EventEmitter();
  bloqueioUsuarioEmitter = new EventEmitter();

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore + 'SegUsuario/';
  }

  findUsuarioById(idUsuario: number): Observable<UsuarioModel> {
    const url = this.environmentUrl + 'GetUsuario/' + idUsuario;
    return this.httpClient.get<UsuarioModel>(url);
  }

  getUsuarios(text: string, pagina: number, totPag: number, filtro?: UsuarioListaFiltro): Observable<UsuarioModel[]> {
    if (text == '') {
      text = 'null';
    } else {
      text = text.replace('\\', '').replace('/', '');
    }

    let params = new HttpParams();
    Object.entries(filtro ?? {}).forEach(([chave, valor]) => {
      if (valor !== null && valor !== undefined && `${valor}`.trim() !== '') {
        params = params.set(chave, `${valor}`.trim());
      }
    });

    const url = this.environmentUrl + 'GetUsuarios/' + text + '/' + pagina + '/' + totPag;
    return this.httpClient.get<UsuarioModel[]>(url, { params });
  }

  setUsuario(usuarioModel: UsuarioModel) {
    const params = {
      IdUsuario: usuarioModel.idUsuario,
      Login: usuarioModel.login,
      Senha: usuarioModel.senha,
      ConfirmacaoSenha: usuarioModel.confirmacaoSenha,
      Nome: usuarioModel.nome,
      NomeEmpresa: usuarioModel.nomeEmpresa,
      UltimoAcesso: usuarioModel.ultimoAcesso,
      Email: usuarioModel.email,
      Perfil: usuarioModel.perfil,
      Empresa: usuarioModel.empresa,
      EmpresaTerceira: usuarioModel.empresaTerceira,
      IdEmpresaTerceira: usuarioModel.idEmpresaTerceira,
      IdHierarquia: usuarioModel.idHierarquia,
      NomeHierarquia: usuarioModel.nomeHierarquia,
      IdFuncionario: usuarioModel.idFuncionario,
      NomeFuncionario: usuarioModel.nomeFuncionario,
      PerfisConcatenados: usuarioModel.perfisConcatenados,
      NomePerfil: usuarioModel.nomePerfil,
      FlagBloqueado: usuarioModel.flagBloqueado,
      FlagUsuarioProprio: usuarioModel.flagUsuarioProprio,
      ListaPerfil: usuarioModel.listaPerfil,
      ListaEmpresa: usuarioModel.listaEmpresa,
    };

    const url = this.environmentUrl + 'SetItem';
    return this.httpClient.post<MensagemErro[]>(url, params);
  }

  delUsuario(idUsuario: number) {
    const url = this.environmentUrl + 'DelItem/' + idUsuario;
    return this.httpClient.delete<boolean>(url);
  }

  desbloquearUsuario(idUsuario: number): Observable<Retorno> {
    const params = {
      IdUsuario: idUsuario,
    };
    const url = this.environmentUrl + 'SetUsuarioDesbloquear';
    return this.httpClient.post<Retorno>(url, params);
  }

  setDadosUsuario(payload: DadosUsuarioInput): Observable<Retorno> {    
    const url = this.environmentUrl + 'SetDadosUsuario';
    return this.httpClient.put<Retorno>(url, payload);
  }
}
